module.exports = __webpack_public_path__ + "static/media/09_CORTINAO_SEM_BOJO_ESTAMPADO_01.49947821.jpg";